import { useTranslation } from 'react-i18next';

export function CtaBar() {
  const { t } = useTranslation();
  return (
    <section className="relative overflow-hidden bg-slate-900 py-20">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-teal-500 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-purple-500 rounded-full blur-3xl"></div>
      </div>

      <div className="relative mx-auto max-w-7xl px-4 text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 tracking-tight">
          {t('cta.title')}
        </h2>
        <p className="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto mb-10 leading-relaxed">
          {t('cta.desc')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="/contact" className="btn-primary text-base px-8 py-4 bg-teal-500 hover:bg-teal-400 border-transparent">
            {t('cta.get_started')}
          </a>
          <a href="/contact" className="btn-secondary text-base px-8 py-4 bg-transparent text-white border-slate-600 hover:bg-white/10 hover:text-white">
            {t('cta.contact')}
          </a>
        </div>
        <p className="mt-8 text-sm text-slate-400">
          {t('cta.disclaimer')}
        </p>
      </div>
    </section>
  );
}
